module.exports = __webpack_public_path__ + "static/img/coupon-used-bg.567467a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new-user/coupon-used-bg.png
// module id = MWLk
// module chunks = 4